import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Container = styled.div``;

const Title = styled.h1`
  text-align: center;
  margin: 0 0 16px 0;
  color: rgb(104 38 85);
  @media (max-width: 700px) {
  }
`;
const Section = styled.div`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  color: rgb(104 38 85);
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
`;

const Paragraph = styled.p`
  font-size: 1.05rem;
  line-height: 1.6;
  color: #333;
`;

const WhatWeDo: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container className="WhatWeDo">
      <Title>{t("whatWeDo.title").toUpperCase()}</Title>

      <Section>
        <SectionTitle>{t("whatWeDo.mission.title")}</SectionTitle>
        <Paragraph>{t("whatWeDo.mission.body")}</Paragraph>
      </Section>

      <Section>
        <SectionTitle>{t("whatWeDo.vision.title")}</SectionTitle>
        <Paragraph>{t("whatWeDo.vision.body")}</Paragraph>
      </Section>
    </Container>
  );
};

export default WhatWeDo;
